// DefectsInput.tsx
// 不良情報登録モーダル
import React, {
  useState,
  useEffect,
  useRef,
  RefObject,
  createRef,
} from "react";
import "./DefectsInput.css";
import { DefectsCanvas, DefectsCanvasRefMethods } from "./DefectsCanvas";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { DefectsImageProp, setDefectsDetails } from "../../redux/defectsSlice";
import cloneDeep from "lodash/cloneDeep";
import RippleButton from "../ui/rippleButton";

interface Props {
  index: number;
  closeModal: any;
}

const DefectsInput: React.FC<Props> = ({ index, closeModal }) => {
  const dispatch: AppDispatch = useDispatch();
  const defectsDetails = useSelector(
    (state: RootState) => state.defects.defectsDetails
  );
  const [canvasNo, setCanvasNo] = useState(0);
  const [inputList, setInputList] = useState<any[]>([]);
  const canvasRefs = useRef<RefObject<DefectsCanvasRefMethods>[]>([]);

  // Canvas追加
  const createInput = (canvasIndex: number) => {
    canvasRefs.current[canvasIndex] = createRef<DefectsCanvasRefMethods>();
    return (
      <>
        <DefectsCanvas
          ref={canvasRefs.current[canvasIndex]}
          canvasId={"canvas_id_" + canvasIndex}
        />
      </>
    );
  };
  // Canvas追加
  const handleAddDefectsInput = () => {
    const newInputList = [...inputList];
    setInputList([...newInputList, createInput(newInputList.length)]);
    setCanvasNo(canvasNo + 1);
  };

  // 初期値として、ひとつCanvasを作成
  useEffect(() => {
    handleAddDefectsInput();
  }, []);

  // 画像登録
  const handleRegist = () => {
    const images: DefectsImageProp[] = [];
    canvasRefs.current.forEach((d) => {
      const data = d.current?.getDefectImage();
      if (data !== undefined && data !== "") {
        images.push({
          images: data,
          key: "",
          state: "unregistered",
        });
      }
    });
    // stateを更新するためコピーを作成
    const newDefectsDetails = cloneDeep(defectsDetails);
    newDefectsDetails[index].defectsImages = [
      ...newDefectsDetails[index].defectsImages,
      ...images,
    ];

    dispatch(setDefectsDetails(newDefectsDetails));
    // モーダルを閉じる
    closeModal();
  };

  return (
    <>
      <div className="defects-input-base-container">
        <div className="title-item defects-input-title">
          不良状況のスケッチ/写真登録
        </div>
        <div className="defects-input-scroller-container defects-input-scroller">
          {inputList}
        </div>
        <div className="defects-input-add-button-item">
          <img
            src="images/defects-add.svg"
            alt="layout Icon"
            className="icon"
            onClick={() => handleAddDefectsInput()}
          />
        </div>
        <div className="defects-regist-button-item">
          <RippleButton
            width={"192px"}
            heihgt={"48px"}
            borderRadius={"8px"}
            onClick={handleRegist}
            effectSize={160}
            className="bk-secondary"
          >
            <span className="children">登録</span>
          </RippleButton>
        </div>
      </div>
    </>
  );
};

export default DefectsInput;
